import { GetStaticProps, NextPage } from "next";
import NextLink from "next/link";

import { Link } from "@releaseit/ui";

import { Seo } from "@/components";
import { type Community, getAllCommunities } from "@/features/search";

type Props = {
  states: Record<string, Community[]>;
};

export const getStaticProps: GetStaticProps<Props> = async () => {
  const states: Record<string, Community[]> = {};
  const communities = await getAllCommunities();

  communities.forEach((c) => {
    states[c.State] ??= [];
    states[c.State].push(c);
  });

  return {
    props: { states },
  };
};

const CommunitiesPage: NextPage<Props> = ({ states }) => (
  <>
    <Seo templateTitle="Our communities" />

    <div className="container mt-16 mb-32">
      <h1 className="text-5xl font-medium">Our communities</h1>

      <p className="mt-2">
        View our growing communities and see what is available for rent in those areas.
      </p>

      <div className="mt-4 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
        {Object.entries(states).map(([state, communties]) => (
          <div key={state}>
            <h2 className="text-3xl">{state}</h2>
            <ul className="mt-2">
              {communties.map((community) => (
                <li key={community.UrlSlug}>
                  <NextLink
                    href={`/community/${community.State.toLowerCase()}/${community.UrlSlug}`}
                    passHref
                  >
                    <Link>Hire in {community.CommunityName}</Link>
                  </NextLink>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  </>
);

export default CommunitiesPage;
